import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { ExternalValuationProps, TrackIndex } from "./index";
import { ExValProperty, PostExValData, ValuationCompany } from "../../valuationapi/entities";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import ValuationCompanyDetails from "@my-dld/components/ExternalValuation/ValuationCompanyDetails";
import ValuationDetailsForm from "@my-dld/components/ExternalValuation/ValuationForm";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { ExternalValuationApi } from "../../valuationapi";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { exToMessage } from "@eres/ssoapi/api";
import { navigate } from "@my-dld/utils/StoreUtils";
import { JQModal } from "@my-dld/components/Popup/Utils";
import ValuationSuccessPopUp from "../../components/ExternalValuation/ValuationSuccessPopUp";
import ValuationCompanyRankingDetails from "./ValuationCompanyRankingDetails";
import { openBinaryAsDocument } from "@my-dld/utils/Utils";

interface LookupState {
	ValuationCompanies?: ValuationCompany[];
}

interface Props extends ExternalValuationProps {

}

interface State extends LookupState {
	property: AssetCard;
	refNumber?: string;
	showRankingDetails?: boolean;
}

class ValuationForm extends Component<Props, State> {
	apiHandler: any;
	apiExHandler: any;
	propertyId: any;

	constructor( props: ExternalValuationProps ) {
		super( props );
		this.state = {
			property: props.property,
			showRankingDetails: false,
		};
	}

	componentDidMount() {
	}

	getPropertyId() {
		let id: number | undefined = 0;
		if ( this.props.property.propertyTypeId === TabuPropertyType.LAND ) {
			if ( !this.props.emptyLand() ) {
				id = this.props.getValuationScope().id;
			} else {
				id = this.props.property.propertyTypeId;
			}
		} else {
			id = this.props.property.propertyTypeId;
		}
		return id;
	}

	submitValuationRequest( remarks: String | undefined ) {
		showLoading();
		let property: ExValProperty = {
			propertyTypeId: this.props.property.propertyTypeId,
			tabuPropertyId: this.props.property.tabuPropertyId
		};
		let request: PostExValData = {
			evaluationCompany: {
				id: this.props.getValuationCompany().id,
				name: this.props.getValuationCompany().name
			},
			evaluationReason: this.props.getValuationReason(),
			property: property,
			propertyTypeId: this.getPropertyId(),
			requestNotes: remarks ? remarks : ""
		};

		ExternalValuationApi.submitTabuEvaluationRequest( JSON.stringify( request ) ).then( ( response: any ) => {
			hideLoading();
			if ( response.validationErrorsList && response.validationErrorsList.length > 0 ) {
				showErrorMessage( ExternalValuationApi.getValidationError( response.validationErrorsList ) );
			} else {
				if ( response.response.request && response.response.request.requestNumber && response.response.request.requestNumber.length > 0 ) {
					this.setState( { refNumber: response.response.request.requestNumber } );
					setTimeout( () => {
						JQModal( "SuccessMsgExternalValuation" ).show();
					}, 200 );
				}

			}
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				let key = "newPwd";
				if ( message.src && message.src === "old" ) {
					key = "current";
				}
			} );
		} );
	}

	fetchRankingDetails() {
		setTimeout( () => {
			JQModal( "ValuationCompanyRankingDetails" ).show();
		}, 200 );
	}

	getValuationCompanyCertificate() {
		showLoading();
		ExternalValuationApi.downloadOfficeCertificate( this.props.getValuationCompany().realEstateNumber + "" ).then( ( response: any ) => {
			hideLoading();
			if ( response.Errors && response.Errors.length > 0 ) {
				showErrorMessage( ExternalValuationApi.getValidationError( response.Errors ) );
			} else {
				if ( response.Response != undefined && response.Response.Object ) {
					openBinaryAsDocument( response.Response.Object, "Company Certificate", "application/pdf" );

				}
			}
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				let key = "newPwd";
				if ( message.src && message.src === "old" ) {
					key = "current";
				}
			} );
		} );
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
		};
		const { property } = this.state;
		return <>
			<ValuationCompanyDetails
				company={ this.props.getValuationCompany() }
				onDownloadCertificate={ () => {
					this.getValuationCompanyCertificate();
				} }
				onViewRankingDetails={ () => {
					this.setState( { showRankingDetails: true }, () => {
						this.fetchRankingDetails();
					} );
				} }/>
			<ValuationDetailsForm
				isEmptyLand={ this.props.emptyLand() }
				property={ property }
				onValuationReasonChange={ ( reason ) => {
					this.props.setValuationReason( reason );
				} }
				onValuationScopeChange={ ( scope ) => {
					this.props.setValuationScope( scope );
				} }
				onCancel={ () => {
					this.props.onPrevious( TrackIndex.SELECT_VALUATION_COMPANY );
				} }
				onSubmit={ ( remarks ) => {
					this.submitValuationRequest( remarks );
				} }
			/>
			<ValuationSuccessPopUp
				refNumber={ this.state.refNumber } onHomePressed={ () => {
				navigate( "/mydld" );
			} }/>
			{ this.state.showRankingDetails &&
				<ValuationCompanyRankingDetails
					company={ this.props.getValuationCompany() } onClose={ () => {
					this.setState( { showRankingDetails: false } );
				} }/> }

		</>;
	}

}

export default ValuationForm;
